module.exports = __webpack_public_path__ + "static/img/10.d1bf33f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/10.png
// module id = pyhg
// module chunks = 0